import { render } from "./LayoutApp.vue?vue&type=template&id=73bb5faa&scoped=true&ts=true"
import script from "./LayoutApp.vue?vue&type=script&lang=ts"
export * from "./LayoutApp.vue?vue&type=script&lang=ts"

import "./LayoutApp.vue?vue&type=style&index=0&id=73bb5faa&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bb5faa"]])

export default __exports__